import React, { useEffect, useState } from 'react';
import close from "../../../../../../../../assets/close.svg";
import { Link, useLocation } from 'react-router-dom';
import moment from 'moment';
import axiosApi from '../../../../../../../../core/interceptor/interceptor';
import { config } from '../../../../../../../../config';

export default function TextDetailUserModal(props) {
  const [formData, setFormData] = useState({});
  const [recipients, setRecipients] = useState([]);

  useEffect(() => {
    setFormData({
      created_at: props.data.created_at,
      recipients_id: props.data.recipients_id,
      body: props.data.body,
      schedule_date_time_tz: props.data?.schedule_date_time_tz,
    });
    getRecipients(props.data.id)
    //eslint-disable-next-line
  }, []);

  /*** closes modal *****/
  const closeModal = () => {
    props.closeModal();
  }

  const search = useLocation().search;
  const leagueId = new URLSearchParams(search).get('leagueId');

  /***** Get Recipients *****/
  const getRecipients = (messageUserId) => {
    axiosApi.post(`${config.apiUrl}/misc/recipients/${messageUserId}`).then((response) => {
      if (response.data && response.data.data && response.data.data.length) {
        setRecipients(response.data.data);
      }
    }).catch((err) => {
      console.error(err);
    });
  }
  return <>
    <div className="modal">
      <div className="modal-header">
        <h2>SMS Details</h2>
        <p>Sent {moment(formData.created_at).format('M/D/YYYY [at] hh:mm A')}</p>
        <span className="close" onClick={closeModal}>
          <img src={close} alt='close-icon' />
        </span>
      </div>
      <div className="emailArchive-popup messageArchive-popup text-msg-details-popup">
        <div className="archivePopup-header">
          <div className="text-blk">
            <span className="label">Number of Recipients:</span>
            <span className="value">{formData.recipients_id}</span>
          </div>
          <div className="text-blk">
            <span className="label">{ formData?.schedule_date_time_tz ? (moment(formData.schedule_date_time_tz).isBefore(moment()) ? 'Sent To:' : 'Scheduled For:' ) : 'Sent To:' }</span>
            <span className="value">
              {
                recipients.map((recipient, idx) => <span key={idx}>{recipient.name + (idx < recipients.length - 1 ? ', ' : '')}</span>)
              }
            </span>
          </div>
        </div>
        <div className="archivePopup-content">
          <div className="body-blk">
            <span>Message Body</span>
            <div className="content-wrapper">
              <pre style={{ overflowWrap: 'break-word' }}>{formData.body}</pre>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-footer d-flex">
        <button onClick={closeModal}>close</button>
      </div>
    </div>
  </>
}